import { render } from "./BaseLoadingIcon.vue?vue&type=template&id=ab2a215a"
import script from "./BaseLoadingIcon.vue?vue&type=script&lang=js"
export * from "./BaseLoadingIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__